import Immutable from "seamless-immutable";

const initialState = Immutable({});

const AggregatorReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default AggregatorReducer;
